<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon :icon="['fal', 'language']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption">{{ printLang }}</v-list-tile-sub-title>
      <v-list-tile-title>{{ printLevel }}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-menu offset-y>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading || isLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3">
        <v-select
          v-model="form.lang"
          label="言語"
          item-text="text"
          item-value="value"
          :rules="rules.lang"
          :items="getLangItems"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3">
        <v-select
          v-model="form.level"
          label="自己申告の語学レベル"
          :rules="rules.level"
          :items="getLevelItems"></v-select>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutBackgroundsLang',
  components: {
    UtilConfirmModal
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'lang',
        status: {
          loading: false
        }
      },
      meta: {
        levels: [
          '入門', '初級', '中級（下）', '中級', '中級（上）', '上級'
        ]
      },
      form: {
        id: '',
        lang: '',
        level: ''
      },
      rules: {
        lang: [
          v => !!v || '必須項目です'
        ],
        level: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          lang: dt.lang ? dt.lang : 'english',
          level: dt.level ? dt.level : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          lang: this.$props.data.lang ? this.$props.data.lang : 'english',
          level: this.$props.data.level ? this.$props.data.level : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('lang_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: '語学力の削除',
        message: 'この語学力を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.axios.post(this.$url.api + 'user/about/delete/meta', {
            id: this.$props.data.id
          }, {
            headers: {
              'user-token': this.$localStorage.get('jwt')
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'remove',
                data: {
                  type: 'langs',
                  id: res.data.data.id ? res.data.data.id : ''
                }
              })
            }
          })
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('lang_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('lang_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('lang_' + this.$props.data.id)
      )
    },
    printLevel () {
      return (
        this.$props.data &&
        this.$props.data.level
      ) ? this.$props.data.level : '語学力'
    },
    printLang () {
      return (
        this.$props.data &&
        this.$props.data.lang &&
        this.$meta.langs[this.$props.data.lang]
      ) ? this.$meta.langs[this.$props.data.lang] : ''
    },
    isLangEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.lang
      )
    },
    getLangItems () {
      return Object.keys(this.$meta.langs).map(key => {
        return {
          text: this.$meta.langs[key],
          value: key
        }
      })
    },
    getLevelItems () {
      return this.meta.levels
    }
  }
}
</script>
